import { render, staticRenderFns } from "./ImportantNews.vue?vue&type=template&id=2834ae64&scoped=true"
import script from "./ImportantNews.vue?vue&type=script&lang=js"
export * from "./ImportantNews.vue?vue&type=script&lang=js"
import style0 from "./ImportantNews.vue?vue&type=style&index=0&id=2834ae64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834ae64",
  null
  
)

export default component.exports